import { render, staticRenderFns } from "./Refunds.vue?vue&type=template&id=6b945366&scoped=true&"
import script from "./Refunds.vue?vue&type=script&lang=js&"
export * from "./Refunds.vue?vue&type=script&lang=js&"
import style0 from "./Refunds.vue?vue&type=style&index=0&id=6b945366&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b945366",
  null
  
)

export default component.exports